import { createAsyncReducer } from '../../standard-actions/reducers';
import { initialState } from '../state/initial-state';
import { IOrderTrackerState } from '../state';
import {
    ILoadProductOrderListErrorAction,
    ILoadProductOrderListResetAction,
    ILoadProductOrderListStartAction,
    ILoadProductOrderListSuccessAction,
    IUpdateFiltersAction,
    IUpdateSelectedColumnsAction,
} from '../actions/product-order-list';
import { ErrorTypes } from '../state/product-order-list';

type ILoadProductSuccessConsolidated =
| ILoadProductOrderListSuccessAction
| IUpdateSelectedColumnsAction
| IUpdateFiltersAction

export type LoadProductOrderListAction =
    | ILoadProductOrderListStartAction
    | ILoadProductSuccessConsolidated
    | ILoadProductOrderListErrorAction
    | ILoadProductOrderListResetAction;

const init = (
    state: IOrderTrackerState,
    action: LoadProductOrderListAction
): IOrderTrackerState => {
    const startAction = action as ILoadProductOrderListStartAction;
    const { error, ...rest} = state.productOrderList;
    return {
        ...state,
        productOrderList: {
            ...rest,
            status: action.status,
            tableConfig:
                startAction.data?.tableConfig ??
                state.productOrderList.tableConfig,
            selectedFilters:
                startAction.data?.selectedFilters ??
                state.productOrderList.selectedFilters,
            searchText:
                typeof startAction.data?.searchText === 'string'
                    ? startAction.data.searchText
                    : state.productOrderList.searchText,
            sortParam:
                startAction.data?.sortParam ??
                state.productOrderList.sortParam,
            selectedColumns:
                startAction.data?.selectedColumns || state.productOrderList.selectedColumns,
            hideFilterAction: !!startAction.data?.hideFilterActions
        },
    };
};

const success = (
    state: IOrderTrackerState,
    action: LoadProductOrderListAction
): IOrderTrackerState => {
    return {
        ...state,
        productOrderList: {
            ...state.productOrderList,
            status: (
                action as ILoadProductSuccessConsolidated).updateState
                ? action.status
                : state.productOrderList.status,
            productList:
                (action as ILoadProductOrderListSuccessAction).data
                    ?.productList || state.productOrderList.productList,
            selectedColumns:
                (action as IUpdateSelectedColumnsAction).data
                    ?.selectedColumns || state.productOrderList.selectedColumns,
            filters:
                (action as IUpdateFiltersAction).data?.filters ||
                state.productOrderList.filters,
            ...((action as ILoadProductSuccessConsolidated).updateState && {
                hideFilterAction: false
            })
        },
    };
};

const failure = (
    state: IOrderTrackerState,
    action: LoadProductOrderListAction
): IOrderTrackerState => {
    return {
        ...state,
        productOrderList: {
            ...state.productOrderList,
            status: (action as ILoadProductOrderListErrorAction).status,
            error: (action as ILoadProductOrderListErrorAction).error,
            hideFilterAction: !!(action as ILoadProductOrderListErrorAction)
                .hideFilterActions,
            ...(state.productOrderList.productList && {
                productList: {
                    ...state.productOrderList.productList,
                    products: [],
                    totalProducts:
                        (action as ILoadProductOrderListErrorAction).error ===
                        ErrorTypes.NoResults
                            ? 0
                            : state.productOrderList.productList.totalProducts,
                },
            }),
        },
    };
};

const reset = (
    state: IOrderTrackerState,
    action: LoadProductOrderListAction
): IOrderTrackerState => {
    return {
        ...state,
        productOrderList: {
            ...state.productOrderList,
            status: (action as ILoadProductOrderListErrorAction).status,
            productList: null
        },
    };
};

export const loadProductOrderListReducer = createAsyncReducer(
    initialState,
    init,
    success,
    failure,
    reset
);
